enum LikesTabsEnum {
  GROUPS = "GROUPS",
  SEARCH = "SEARCH",
}

export default LikesTabsEnum;
